/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the IdentityApiConfiguration configuration object with a given root URL.
 */
export function provideIdentityApiConfiguration(rootUrl: string) {
  var config = new IdentityApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: IdentityApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class IdentityApiConfiguration {
  rootUrl: string = '/';
}

